import React, { useState, useEffect, useRef } from "react";
import { NavLink, useParams } from "react-router-dom";
import {
  getSingleBookingById,
  getPartners,
  assignBookingToPartner,
  updateBookingRequestStatus,
  updateOrderQuotationDecision,
  getPrivateFileBlob,
  uploadTransitSingleFile,
  deleteOrderHistory,
} from "../Services/userService";
import { updateBookingStatus } from "../Services/bookingService";
import {
  logisticTypes,
  customStyles,
  STATUS_OPTIONS,
  RoutesPaths,
} from "../Router/constant";
import moment from "moment";
import { toast } from "react-toastify";
import Skeleton from "../Components/SkeletonLoader";
import ConfirmationModal from "../Components/ConfirmationModal";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { quotationFileUpload } from "../Services/bookingService";
import { CreateRoomMessage } from "../Services/messagesService";
import {
  FiArrowLeft,
  FiBell,
  FiBox,
  FiCalendar,
  FiCheck,
  FiChevronRight,
  FiCopy,
  FiDownload,
  FiEdit2,
  FiFileText,
  FiHash,
  FiHome,
  FiLock,
  FiMail,
  FiMapPin,
  FiMessageSquare,
  FiPackage,
  FiPaperclip,
  FiPhone,
  FiRefreshCw,
  FiTrash2,
  FiTruck,
  FiUploadCloud,
  FiUser,
} from "react-icons/fi";
import { MdErrorOutline, MdOutlineWarehouse, MdStorefront } from "react-icons/md";
import { FiExternalLink, FiEye } from "react-icons/fi";
import {
  generateDeliveryOrderPdf,
  generateWorkOrderPdf,
} from "../Utils/pdfGenerator";

export default function Bookingmanagementdetail() {
  const DELETE_ALLOWED_STATUSES = [
    "submitted for quote",
    "quote in place and sent to client for approval",
    "quote approved by client",
    "quote rejected by client",
    "order accepted",
    "in transit",
    "delivered",
  ];
  const [actionLoading, setActionLoading] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const fileInputRef = useRef(null);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const triggerRef = useRef(null);
  const [isQuotationUploaded, setIsQuotationUploaded] = useState(false);
  const handleIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const navigate = useNavigate();
  const { id } = useParams();
  const [bookingData, setBookingData] = useState(null);
  const [acceptanceLoading, setAcceptanceLoading] = useState(null);
  const [quotationActionLoading, setQuotationActionLoading] = useState(false);
  const [quotationActionConfirmation, setQuotationActionConfirmation] =
    useState({
      show: false,
      quotation: null,
      status: "",
    });
  const [reasonQuotationMessage, setReasonQuotationMessage] = useState("");
  const [assignLoading, setAssignLoading] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState({
    show: false,
    status: null,
  });
  const [partnersData, setPartnersData] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState(null);

  useEffect(() => {
    if (id) fetchBookingData();
    if (id) fetchPartnerData();
  }, [id]);

  useEffect(() => {
    if (bookingData?.quotationPdf) {
      setIsQuotationUploaded(true);
    }
  }, [bookingData]);
  const userRole = localStorage.getItem("userRole");
  const [loadError, setLoadError] = useState(false);
  const fetchBookingData = async () => {
    try {
      const res = await getSingleBookingById(id);
      const order = res?.data?.data?.order || null;
      setBookingData(order);
      setLoadError(!order);
      if (order?.assignPartner?._id) {
        setSelectedPartner(order.assignPartner._id);
      }
    } catch (error) {
      console.error("Error fetching booking:", error);
      // Only surface an error when there is nothing to show yet.
      setLoadError((prev) => prev || !bookingData);
    }
  };

  const fetchPartnerData = async () => {
    try {
      const res = await getPartners(id);
      setPartnersData(res?.data?.data);
    } catch (error) {
      console.error("Error fetching partners:", error);
    }
  };
  const [deleteLoading, setDeleteLoading] = useState(false);
  const orderId = bookingData?.orderId;
  const trackNumber = bookingData?.trackNumber || "--";
  const name = bookingData?.name;
  const phoneNumber = bookingData?.phoneNumber;
  const logisticsType = bookingData?.logisticsType;
  const createdAt = bookingData?.createdAt;
  const productDetails = bookingData?.productDetails || [];
  const orderHistory = bookingData?.orderHistory || [];
  const status = bookingData?.status;
  const totalProducts = bookingData?.productDetails?.length || 0;
  const formattedDate = moment(createdAt).format("DD MMM YYYY, hh:mm A");
  const logisticsLabel = logisticTypes[logisticsType] || "N/A";

  const handleCopyToClipboard = (text) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
      toast.success("Copied to clipboard!");
    } else {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      alert("Order ID copied to clipboard!");
    }
  };
  const [quotationFile, setQuotationFile] = useState();
  const [quotationLoader, setQuotationLoader] = useState(true);
  const [quotationLoading, setQuotationLoading] = useState(false);
  const handleQuotationFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const isImage = file.type.startsWith("image/");
    const isPdf = file.type === "application/pdf";

    if (!isImage && !isPdf) {
      toast.error("Only images or PDF files are allowed");
      return;
    }
    setQuotationFile(file);
    setIsQuotationUploaded(true); // <-- make bar green
    setQuotationLoader(false);
  };

  const handleQuotationSubmit = async () => {
    try {
      setQuotationLoading(true);
      const response = await quotationFileUpload(
        orderId,
        quotationFile,
        userRole,
      );
      toast.success(response?.data?.message);
      fetchBookingData();
      setQuotationLoader(true);
    } catch (err) {
      console.error("File upload failed:", err);
      toast.error(err?.response?.data?.data);
      setQuotationLoader(true);
      setQuotationLoading(false);
    } finally {
      setQuotationLoading(false);
    }
  };

  const handleQuotationCancel = () => {
    setQuotationFile(" ");
    setIsQuotationUploaded(false); // <-- make bar green
    setQuotationLoader(true);
  };

  const handleOpenPartnerQuotationAction = (quotation, status) => {
    setReasonQuotationMessage("");
    setQuotationActionConfirmation({
      show: true,
      quotation,
      status,
    });
  };

  const handleClosePartnerQuotationAction = () => {
    setQuotationActionConfirmation({
      show: false,
      quotation: null,
      status: "",
    });
    setReasonQuotationMessage("");
  };

  const handlePartnerQuotationAction = async () => {
    const { quotation, status } = quotationActionConfirmation;
    const quotationId =
      quotation?._id || quotation?.id || quotation?.quotationId;

    if (!quotationId || !status || quotationActionLoading) return;
    if (status === "rejected" && !reasonQuotationMessage.trim()) {
      toast.error("Please enter a rejection reason.");
      return;
    }

    setQuotationActionLoading(true);
    try {
      const response = await updateOrderQuotationDecision({
        orderId,
        isQuotationAccepted: status === "accepted",
        reasonQuotationMessage:
          status === "rejected" ? reasonQuotationMessage.trim() : "",
        quotationId,
      });
      toast.success(response?.data?.message || `Quotation ${status}`);
      fetchBookingData();
      handleClosePartnerQuotationAction();
    } catch (error) {
      console.error("Quotation status update failed:", error);
      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.data ||
          "Failed to update quotation status.",
      );
    } finally {
      setQuotationActionLoading(false);
    }
  };

  const handleAssignPartner = async () => {
    if (!selectedPartner) {
      toast.error("Please select a vendor first.");
      return;
    }

    setAssignLoading(true);
    try {
      const res = await assignBookingToPartner(id, selectedPartner);

      if (res?.data?.status === true) {
        toast.success("Order assigned to vendor successfully!");
        fetchBookingData(); // refresh data
      } else {
        toast.error(res?.data?.message || "Failed to assign vendor");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong while assigning vendor");
    }
    setAssignLoading(false);
  };

  const handleView = async (filename) => {
    const newTab = window.open("", "_blank");

    try {
      const res = await getPrivateFileBlob(filename);

      const blob = new Blob([res.data], {
        type: res.headers?.["content-type"] || "application/pdf",
      });

      const url = URL.createObjectURL(blob);
      newTab.location.href = url;

      setTimeout(() => URL.revokeObjectURL(url), 60_000);
    } catch (err) {
      newTab?.close();
      alert("Unable to open document (token invalid or file missing).");
    }
  };
  const confirmDeleteHistory = async () => {
    if (!deleteConfirmation.status) return;
    setDeleteLoading(true);
    try {
      const res = await deleteOrderHistory(
        bookingData._id,
        deleteConfirmation.status,
      );

      if (res?.data?.success === true) {
        toast.success("Order history deleted successfully!");
        fetchBookingData();
      } else {
        toast.error(res?.data?.message || "Delete failed");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong while deleting");
    }

    setDeleteLoading(false);
    setDeleteConfirmation({ show: false, status: null });
  };
  const handleResponse = async (acceptValue) => {
    if (acceptanceLoading) return;
    setAcceptanceLoading(acceptValue ? "accept" : "reject");
    try {
      const res = await updateBookingRequestStatus(id, acceptValue);
      toast.success(res.data.message);
      if (acceptValue === false) {
        navigate("/booking-management");
      } else {
        fetchBookingData();
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setAcceptanceLoading(null);
    }
  };

  const normalize = (str) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const normalizedLabel = normalize(logisticsLabel);

  const matchedPartners = partnersData.filter((partner) => {
    const hasMatchingService =
      Array.isArray(partner.serviceTypes) &&
      partner.serviceTypes.some((type) => normalize(type) === normalizedLabel);

    const isPartnerAccepted = partner.status === "accepted";

    const isContractAccepted =
      partner.partnershipContract?.status === "accepted";

    return hasMatchingService && isPartnerAccepted && isContractAccepted;
  });

  const lastQuotationWithPdf =
    bookingData?.quotation
      ?.slice()
      ?.reverse()
      ?.find((q) => q.quotationPdf) || null;

  const STATUS_LABEL = {
    accepted: "Accepted",
    rejected: "Rejected",
    opening: "Pending",
  };

  const STATUS_COLOR = {
    accepted: "#60B526",
    rejected: "#ff0000",
    opening: "#FFC22E",
  };

  const STATUS_OWNER = {
    opening: userRole === "partner" ? "Vendor :" : " Admin :",
    accepted: "User :",
    rejected: "User :",
  };

  const getQuotationStatusLabel = (item) => {
    return STATUS_LABEL[item.status] || "Pending";
  };

  const getQuotationStatusColor = (item) => {
    return STATUS_COLOR[item.status] || "#e9be20";
  };

  const getQuotationOwnerLabel = (item) => {
    return STATUS_OWNER[item.status] || "";
  };
  const quotationHistoryAll = bookingData?.quotation || [];
  const partnerQuotationHistory = bookingData?.partnerQuotation || [];
  const adminQuotationHistory = quotationHistoryAll.filter(
    (q) => q.uploadedBy === "" || q.uploadedBy === "admin",
  );
  const quotationHistory =
    userRole === "partner" ? partnerQuotationHistory : adminQuotationHistory;

  const getLastAcceptedQuotationByPartner = (quotationHistory) => {
    return quotationHistory
      ?.filter(
        (q) =>
          q.status === "accepted" &&
          (q.uploadedBy === "partner" || !q.uploadedBy),
      )
      ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
  };
  const lastAcceptedPartnerQuotation = getLastAcceptedQuotationByPartner(
    partnerQuotationHistory,
  );
  const getLastAcceptedQuotationByAdmin = (quotationHistory) => {
    return quotationHistory
      ?.filter(
        (q) =>
          q.status === "accepted" &&
          (q.uploadedBy === "admin" || q.uploadedBy === ""),
      )
      ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
  };
  const lastAcceptedAdminQuotation = getLastAcceptedQuotationByAdmin(
    adminQuotationHistory,
  );

  const lastQuotation = bookingData?.quotation?.at(-1) || null;
  const quotationStatus = lastQuotation?.isAcceptedQuotation;

  const [activeDropdown, setActiveDropdown] = useState(null);
  const [confirmationShipping, setConfirmationShipping] = useState({
    show: false,
    orderId: null,
    statusValue: "",
  });

  const toggleDropdown = (id) => {
    setActiveDropdown(activeDropdown === id ? null : id);
  };

  const handleStatusClick = (orderId, statusValue) => {
    setConfirmationShipping({
      show: true,
      orderId,
      statusValue,
      customStatus: statusValue?.toLowerCase() === "in transit" ? "" : null,
      messageText: statusValue?.toLowerCase() === "in transit" ? "" : null,
    });

    setActiveDropdown(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!activeDropdown) return;
      if (dropdownRef.current?.contains(event.target)) return;
      if (buttonRef.current?.contains(event.target)) return;
      setActiveDropdown(null);
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeDropdown]);
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setConfirmationShipping((prev) => ({
      ...prev,
      attachment: file,
    }));

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await uploadTransitSingleFile(formData);

      if (response?.data?.status === true) {
        const fileName = response.data.data.fileName;

        setConfirmationShipping((prev) => ({
          ...prev,
          uploadedFileName: fileName,
        }));
      } else {
        toast.error("File upload failed");
      }
    } catch (error) {
      console.error("File upload error:", error);
      toast.error("File upload error");
    }
  };
  const handleConfirm = async () => {
    const { orderId, statusValue, customStatus, messageText } =
      confirmationShipping;

    const resetConfirmation = () => {
      setActiveDropdown(null);
      setConfirmationShipping({
        show: false,
        orderId: null,
        statusValue: "",
        customStatus: "",
        messageText: "",
        attachment: "",
      });
      setConfirmationShipping((prev) => ({
        ...prev,
        attachment: null,
      }));
    };
    // Build payload
    let payload;
    if (statusValue.toLowerCase() === "in transit") {
      payload = {
        status: "in transit",
        customStatus: customStatus || "",
        inTransitMessage: messageText || "",
        attachment: confirmationShipping.uploadedFileName || "",
      };
    } else {
      payload = { status: statusValue };
    }
    try {
      setConfirmLoading(true);
      const response = await updateBookingStatus(orderId, payload);

      if (response?.data?.status) {
        toast.success(response?.data?.data?.message);
        resetConfirmation();
        fetchBookingData();
      } else {
        resetConfirmation();
        toast.error(
          response?.data?.data?.message || "Failed to update order status.",
        );
      }
    } catch (error) {
      console.error("Update booking status error:", error);
      resetConfirmation();
      toast.error(
        error?.response?.data?.data?.message || "An unexpected error occurred.",
      );
    } finally {
      setConfirmLoading(false);
    }
  };
  const formatOrderStatus = (status = "") =>
    status.charAt(0).toUpperCase() + status.slice(1);

  const formatStatusBadge = (status) => {
    const map = {
      pending: "Pending",
      completed: "Completed",
      inprogress: "In-progress",
      "in progress": "In-progress",
      "in-transit": "In-transit",
      "in transit": "In-transit",
    };

    return map[status?.toLowerCase()] || status;
  };
  const hasAcceptedAdminQuotation = quotationHistory?.some(
    (q) => q.status === "accepted" && q.uploadedBy === "admin",
  );

  const handleChatType = async (type) => {
    const payload = {
      orderId: orderId,
      type: type,
    };

    try {
      const response = await CreateRoomMessage(payload);
      const roomId = getCreatedChatRoomId(response);
      const queryParams = new URLSearchParams({ type });

      if (roomId) {
        queryParams.set("roomId", roomId);
      }

      if (orderId) {
        queryParams.set("orderId", orderId);
      }

      if (
        response?.status === 200 ||
        response?.status === 201 ||
        response?.data?.success
      ) {
        navigate(`${RoutesPaths.ADMINMESSAGES}?${queryParams.toString()}`, {
          state: {
            chatType: type,
            roomId,
            orderId,
          },
        });
      }
    } catch (error) {
      toast.error("Unable to open chat.");
      console.error("Create chat room failed:", error);
    }
  };

  const handleDownloadPdf = async (order) => {
    try {
      await generateWorkOrderPdf(order);
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    }
  };

  const handleDownloadDeliveryOrder = async (order) => {
    try {
      await generateDeliveryOrderPdf(order);
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    }
  };

  const isDelivered = bookingData?.orderHistory?.some(
    (item) => item.status === "delivered" && item.completed,
  );
  /* =========================================
     VIEW HELPERS
  ========================================= */

  const prettyLogistics = logisticsLabel
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/^./, (char) => char.toUpperCase());

  const statusKey = String(status || "").toLowerCase().replace(/\s+/g, "");

  const quotationPillClass = (item) =>
    item?.status === "accepted"
      ? "qp-status-accepted"
      : item?.status === "rejected"
        ? "qp-status-rejected"
        : "qp-status-pending";

  const selectStyles = {
    ...customStyles,
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  const isTransitStatus =
    confirmationShipping.statusValue?.toLowerCase() === "in transit";

  const renderSectionHead = (Icon, title, subtitle, action) => (
    <div className="qh-card-head">
      <div className="qd-panel-title">
        <span className="qd-panel-icon">
          <Icon />
        </span>
        <div>
          <h6>{title}</h6>
          {subtitle && <p className="qd-panel-sub">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );

  // Quotation upload + history card, shared by the admin and vendor views.
  const renderQuotationCard = ({
    title,
    lockedTitle,
    lockedDisabled,
    historyTitle,
    historyItemLabel,
  }) => (
    <section className="qd-card qh-card">
      {renderSectionHead(
        FiFileText,
        quotationStatus ? lockedTitle : title,
        "Pdf, jpg or png · Max 5mb",
      )}

      {quotationStatus ? (
        <div className={`qh-upload is-locked ${lockedDisabled ? "is-disabled" : ""}`}>
          <span className="qh-upload-icon">
            <FiLock />
          </span>
          <span className="qh-upload-text">
            <strong>Upload quotation / document / file</strong>
            <small>The quotation has been accepted, so new uploads are locked.</small>
          </span>
        </div>
      ) : (
        <>
          {bookingData?.isAcceptedQuotation ? (
            <div className="qh-upload is-disabled">
              <span className="qh-upload-icon">
                <FiUploadCloud />
              </span>
              <span className="qh-upload-text">
                <strong>Upload quotation / document / file</strong>
                <small>File format: pdf, jpg, png · File size: 5mb</small>
              </span>
            </div>
          ) : (
            <label
              htmlFor="uploadQuotation"
              className={`qh-upload ${quotationFile?.name ? "has-file" : ""}`}
            >
              <span className="qh-upload-icon">
                {quotationFile?.name ? <FiCheck /> : <FiUploadCloud />}
              </span>
              <span className="qh-upload-text">
                <strong>Upload quotation / document / file</strong>
                <small>
                  {quotationFile?.name
                    ? quotationFile.name
                    : "Click to choose · File format: pdf, jpg, png · File size: 5mb"}
                </small>
              </span>
            </label>
          )}

          <input
            id="uploadQuotation"
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            accept="image/*,application/pdf"
            onChange={handleQuotationFileChange}
          />

          <div className="qh-upload-actions">
            <button
              type="button"
              className="qd-btn qd-btn-outline"
              disabled={quotationLoader}
              onClick={() => handleQuotationCancel()}
            >
              Cancel
            </button>
            <button
              type="button"
              className="qd-btn qd-btn-primary"
              disabled={quotationLoader || quotationLoading}
              onClick={handleQuotationSubmit}
            >
              {quotationLoading ? (
                <>
                  <span className="qo-spinner" /> Submitting...
                </>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </>
      )}

      {quotationHistory.length > 0 && (
        <>
          <h6 className="qh-subtitle">{historyTitle}</h6>
          <div className="qh-quote-list">
            {quotationHistory.map((event, index) => (
              <div className="qh-quote" key={event?._id || index}>
                <div className="qh-quote-main">
                  <div className="qh-quote-title">
                    <span>
                      {getQuotationOwnerLabel(event)} {historyItemLabel}
                    </span>
                    <span className={`qc-status ${quotationPillClass(event)}`}>
                      <span className="qu-dot" />
                      {getQuotationStatusLabel(event)}
                    </span>
                  </div>
                  <p>{event.reason || "-"}</p>
                  <small>{moment(event.createdAt).format("DD MMM YYYY, hh:mm A")}</small>
                </div>
                <button
                  type="button"
                  className="qh-attach-btn"
                  onClick={() => handleView(event?.quotationPdf)}
                >
                  <FiPaperclip /> View attachment
                </button>
              </div>
            ))}
          </div>
        </>
      )}
    </section>
  );

  const breadcrumb = (
    <nav className="qd-breadcrumb">
      <NavLink to={RoutesPaths.DASHBOARD} aria-label="Dashboard">
        <FiHome />
      </NavLink>
      <FiChevronRight />
      <NavLink to={RoutesPaths.BOOKINGMANAGEMENT}>Booking management</NavLink>
      <FiChevronRight />
      <span className="qd-breadcrumb-current">Order id : {orderId || id}</span>
    </nav>
  );

  if (!bookingData && loadError) {
    return (
      <div className="container-fluid qd-page">
        {breadcrumb}
        <div className="qd-card qd-panel">
          <div className="qu-empty">
            <span className="qu-empty-art">
              <MdErrorOutline />
            </span>
            <h6>Unable to load this booking</h6>
            <p>The booking could not be found or there was a problem loading it.</p>
            <div className="qd-bookings-tools">
              <NavLink to={RoutesPaths.BOOKINGMANAGEMENT} className="qd-btn qd-btn-outline">
                <FiArrowLeft /> Back to bookings
              </NavLink>
              <button
                type="button"
                className="qd-btn qd-btn-primary"
                onClick={() => {
                  setLoadError(false);
                  fetchBookingData();
                }}
              >
                <FiRefreshCw /> Try again
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const summaryItems = [
    { label: "Track id", Icon: FiHash, value: trackNumber },
    { label: "Customer name", Icon: FiUser, value: name },
    { label: "Phone number", Icon: FiPhone, value: phoneNumber },
    { label: "Date and time", Icon: FiCalendar, value: formattedDate },
    { label: "Logistics type", Icon: FiTruck, value: prettyLogistics },
    {
      label: `Total ${totalProducts > 1 ? "products" : "product"}`,
      Icon: FiPackage,
      value: totalProducts,
    },
  ];

  return (
    <div className="container-fluid qd-page qh-page">
      {/* Breadcrumb + page actions */}
      <div className="qh-topbar">
        {breadcrumb}
        <div className="qd-bookings-tools">
          {!bookingData ? (
            <Skeleton width={260} height={40} />
          ) : (
            <>
              <button
                type="button"
                className="qd-btn qd-btn-outline"
                onClick={() =>
                  isDelivered
                    ? handleDownloadDeliveryOrder(bookingData)
                    : handleDownloadPdf(bookingData)
                }
              >
                <FiDownload /> {isDelivered ? "Delivery order" : "Work order"}
              </button>
              {userRole === "admin" && (
                <button
                  type="button"
                  className="qd-btn qd-btn-primary"
                  onClick={() => handleChatType("user")}
                >
                  <FiMessageSquare /> Chat with user
                </button>
              )}
            </>
          )}
        </div>
      </div>

      {/* Vendor: incoming booking request */}
      {userRole === "partner" && bookingData?.isAccepted === null && (
        <div className="qd-card qh-request">
          <div className="qd-panel-title">
            <span className="qd-panel-icon">
              <FiBell />
            </span>
            <div>
              <h6>Booking request</h6>
              <p className="qd-panel-sub">Are you sure you want to accept this booking request?</p>
            </div>
          </div>
          <div className="qd-bookings-tools">
            <button
              type="button"
              className="qd-btn qp-delete-btn"
              onClick={() => handleResponse(false)}
              disabled={Boolean(acceptanceLoading)}
            >
              {acceptanceLoading === "reject" ? (
                <>
                  <span className="qo-spinner qh-spinner-dark" /> Please wait...
                </>
              ) : (
                "Reject"
              )}
            </button>
            <button
              type="button"
              className="qd-btn qd-btn-primary"
              onClick={() => handleResponse(true)}
              disabled={Boolean(acceptanceLoading)}
            >
              {acceptanceLoading === "accept" ? (
                <>
                  <span className="qo-spinner" /> Please wait...
                </>
              ) : (
                "Accept"
              )}
            </button>
          </div>
        </div>
      )}

      {/* Order summary */}
      <div className="qd-card qh-summary">
        <div className="qh-summary-head">
          <div className="qh-order-id">
            <span className="qh-order-icon">
              <FiBox />
            </span>
            <div>
              <span className="qh-order-label">Order id</span>
              {bookingData ? (
                <div className="qh-order-value">
                  <button
                    type="button"
                    className="qb-order-link"
                    onClick={() => handleDownloadPdf(bookingData)}
                    title="Download work order"
                  >
                    #{orderId}
                  </button>
                  <button
                    type="button"
                    className="qh-copy"
                    onClick={() => handleCopyToClipboard(orderId)}
                  >
                    <FiCopy /> Copy
                  </button>
                </div>
              ) : (
                <Skeleton width={220} height={22} />
              )}
            </div>
          </div>
          {bookingData ? (
            <span className={`qd-status qd-status-${statusKey}`}>
              {formatStatusBadge(status) || "N/A"}
            </span>
          ) : (
            <Skeleton width={100} height={28} />
          )}
        </div>

        <div className="qh-summary-grid">
          {summaryItems.map(({ label, Icon, value }) => (
            <div className="qu-info qh-summary-item" key={label}>
              <span className="qu-info-icon">
                <Icon />
              </span>
              <div className="qu-info-text">
                <span>{label}</span>
                {bookingData ? (
                  <strong>{value || value === 0 ? value : "--"}</strong>
                ) : (
                  <Skeleton width={120} height={16} />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="qh-layout">
        {/* ================= MAIN COLUMN ================= */}
        <div className="qh-main">
          {/* Products */}
          <section className="qd-card qh-card">
            {renderSectionHead(
              FiPackage,
              "Product details",
              bookingData ? `${totalProducts} ${totalProducts === 1 ? "item" : "items"} in this booking` : null,
            )}
            <div className="qh-products">
              {(bookingData ? productDetails : Array(2).fill({})).map((product, idx) => (
                <div className="qh-product" key={idx}>
                  <div className="qh-product-image">
                    {bookingData ? (
                      <img
                        src={
                          product.image
                            ? `${process.env.REACT_APP_IMAGE_URL}/${product.image}`
                            : "/assets/img/default-image.jpg"
                        }
                        alt="Product"
                      />
                    ) : (
                      <Skeleton height={84} width={84} />
                    )}
                  </div>
                  <div className="qh-product-body">
                    {bookingData ? (
                      <>
                        <h6>{product.name || "Unnamed Product"}</h6>
                        <div className="qh-chips">
                          <span><b>Quantity</b> {product?.quantity || "--"}</span>
                          <span><b>Weight</b> {product?.weight ? `${product.weight} Kg` : "--"}</span>
                          <span>
                            <b>Height</b>{" "}
                            {product.height ? `${product.height} ${product.heightOption || ""}` : "--"}
                          </span>
                          <span>
                            <b>Width</b>{" "}
                            {product.width ? `${product.width} ${product?.widthOption || ""}` : "--"}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <Skeleton height={20} width={200} />
                        <Skeleton height={15} width={260} />
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Addresses */}
          <section className="qd-card qh-card">
            {renderSectionHead(FiMapPin, "Pickup & drop address")}
            <div className="qh-addresses">
              {[
                { label: "Pickup address", data: bookingData?.pickupAddress, Icon: FiPackage },
                { label: "Drop address", data: bookingData?.dropAddress, Icon: FiMapPin },
              ].map(({ label, data, Icon }) => (
                <div className="qh-address" key={label}>
                  <span className="qh-address-icon">
                    <Icon />
                  </span>
                  <div>
                    <h6>{label}</h6>
                    {bookingData ? (
                      <>
                        <p>{data?.address || "--"}</p>
                        {data?.houseNo && <small>{data.houseNo}</small>}
                      </>
                    ) : (
                      <Skeleton width={220} height={14} />
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Warehouse storage (only when the order has one) */}
            {bookingData?.warehouse &&
              (() => {
                const storage = bookingData.warehouse;
                // selectedWarehouse is populated (object) but may also come back as just an id
                const wh =
                  storage.selectedWarehouse && typeof storage.selectedWarehouse === "object"
                    ? storage.selectedWarehouse
                    : null;
                const warehouseId = wh?._id || storage.selectedWarehouse || "";
                const req = storage.dimensions || {};
                const size = wh?.dimensions || {};
                const fmt = (d) =>
                  [d.length, d.width, d.height].every((v) => v !== undefined && v !== null && v !== "")
                    ? `${d.length} × ${d.width} × ${d.height} m`
                    : "--";
                const volume =
                  Number(req.length) > 0 && Number(req.width) > 0 && Number(req.height) > 0
                    ? Number(req.length) * Number(req.width) * Number(req.height)
                    : null;
                const days = Number(storage.numberOfDays);
                const lat = Number(wh?.latitude);
                const lng = Number(wh?.longitude);
                const mapsLink =
                  wh && !isNaN(lat) && !isNaN(lng)
                    ? `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
                    : null;
                const cover = wh?.uploadImages?.[0];

                return (
                  <div className="qh-warehouse">
                    <div className="qh-warehouse-head">
                      <span className="qh-warehouse-thumb">
                        {cover ? (
                          <img src={`${process.env.REACT_APP_IMAGE_URL}/${cover}`} alt="" />
                        ) : (
                          <MdOutlineWarehouse />
                        )}
                      </span>
                      <div className="qh-warehouse-title">
                        <span className="qh-warehouse-eyebrow">Warehouse storage</span>
                        <h6>{wh?.name || "Selected warehouse"}</h6>
                        {wh?.location && (
                          <p>
                            <FiMapPin /> {wh.location}
                          </p>
                        )}
                      </div>
                      <div className="qh-warehouse-links">
                        {mapsLink && (
                          <a
                            className="qd-btn qd-btn-outline qd-btn-sm"
                            href={mapsLink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FiExternalLink /> Map
                          </a>
                        )}
                        {userRole === "admin" && warehouseId && (
                          <NavLink
                            to={`${RoutesPaths.WAREHOUSEDETAIL}/${warehouseId}`}
                            className="qd-btn qd-btn-outline qd-btn-sm"
                          >
                            <FiEye /> View
                          </NavLink>
                        )}
                      </div>
                    </div>

                    <div className="qh-warehouse-stats">
                      <div>
                        <span>Storage days</span>
                        <strong>{days > 0 ? `${days} day${days === 1 ? "" : "s"}` : "--"}</strong>
                      </div>
                      <div>
                        <span>Space requested (L × W × H)</span>
                        <strong>{fmt(req)}</strong>
                      </div>
                      <div>
                        <span>Volume</span>
                        <strong>{volume !== null ? `${volume.toLocaleString()} m³` : "--"}</strong>
                      </div>
                      <div>
                        <span>Warehouse size</span>
                        <strong>{fmt(size)}</strong>
                      </div>
                    </div>

                    {wh?.description && <p className="qh-warehouse-desc">{wh.description}</p>}
                  </div>
                );
              })()}
          </section>

          {/* Shipping timeline */}
          <section className="qd-card qh-card">
            {renderSectionHead(
              FiTruck,
              "Shipping details",
              "Track every step of this booking.",
              <div className="qh-status-menu">
                <button
                  ref={buttonRef}
                  type="button"
                  className={`qd-btn qd-btn-primary ${
                    userRole === "partner" && !bookingData?.isAccepted ? "disabledEditBooking" : ""
                  }`}
                  onClick={() => toggleDropdown(bookingData?._id)}
                  disabled={!bookingData || (userRole === "partner" && !bookingData?.isAccepted)}
                >
                  <FiEdit2 /> Update shipping status
                </button>

                {activeDropdown && activeDropdown === bookingData?._id && (
                  <div className="actionDropdown qh-dropdown" ref={dropdownRef}>
                    <ul className="actionDropdownList">
                      {STATUS_OPTIONS.map((statusOption) => {
                        const completedHistory =
                          bookingData?.orderHistory?.filter((h) => h.completed) || [];
                        const latestCompleted =
                          completedHistory[completedHistory.length - 1]?.status?.toLowerCase() || "";

                        return (
                          <li
                            key={statusOption}
                            className={`actionDropdownItem ${
                              latestCompleted === statusOption?.toLowerCase() ? "selected" : ""
                            }`}
                            onClick={() => handleStatusClick(bookingData?._id, statusOption)}
                          >
                            {statusOption.toLowerCase() === "in transit"
                              ? "Other"
                              : statusOption.charAt(0).toUpperCase() + statusOption.slice(1)}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </div>,
            )}

            <div className="qh-timeline">
              {bookingData ? (
                orderHistory.length > 0 ? (
                  orderHistory.map((event, index) => {
                    const canDelete =
                      DELETE_ALLOWED_STATUSES.includes(event.status?.toLowerCase()) &&
                      (["order accepted", "delivered"].includes(event.status?.toLowerCase())
                        ? event.completed
                        : true);

                    return (
                      <div className={`qh-step ${event.completed ? "done" : ""}`} key={index}>
                        <div className="qh-step-rail">
                          <span className="qh-step-dot">{event.completed ? <FiCheck /> : null}</span>
                          {index !== orderHistory.length - 1 && <span className="qh-step-line" />}
                        </div>
                        <div className="qh-step-body">
                          <div className="qh-step-head">
                            <h6>{event.customStatus || formatOrderStatus(event.status)}</h6>
                            {canDelete && (
                              <button
                                type="button"
                                className="qh-step-delete"
                                title="Delete this status"
                                aria-label="Delete this status"
                                onClick={() =>
                                  setDeleteConfirmation({ show: true, status: event.status })
                                }
                              >
                                <FiTrash2 />
                              </button>
                            )}
                          </div>
                          {event.message && <p>{event.message}</p>}
                          {event?.attachment && (
                            <button
                              type="button"
                              className="qh-attach-btn"
                              onClick={() =>
                                window.open(
                                  `${process.env.REACT_APP_IMAGE_URL}/${event.attachment}`,
                                  "_blank",
                                )
                              }
                            >
                              <FiPaperclip /> View attachment
                            </button>
                          )}
                          <small>
                            {event?.timestamp
                              ? moment(event.timestamp).format("DD MMM YYYY, hh:mm A")
                              : "-"}
                          </small>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p className="qpd-empty-text">No order history available.</p>
                )
              ) : (
                [...Array(3)].map((_, index) => (
                  <div className="qh-step" key={index}>
                    <div className="qh-step-rail">
                      <Skeleton circle width={22} height={22} />
                    </div>
                    <div className="qh-step-body">
                      <Skeleton height={15} width={140} />
                      <Skeleton height={12} width={220} />
                    </div>
                  </div>
                ))
              )}
            </div>
          </section>
        </div>

        {/* ================= SIDE COLUMN ================= */}
        <div className="qh-side">
          {/* Assign vendor (admin, after an admin quotation is accepted) */}
          {userRole === "admin" && hasAcceptedAdminQuotation === true && (
            <section className="qd-card qh-card">
              {renderSectionHead(
                MdStorefront,
                "Assign vendor",
                "Select and assign a vendor to this booking to ensure timely service delivery and proper coordination.",
              )}

              {lastAcceptedAdminQuotation?.status === "accepted" &&
                (bookingData?.isAccepted === true || bookingData?.isAccepted === null) &&
                (() => {
                  const isDisabled = !lastAcceptedAdminQuotation?.quotationPdf
                    ? true
                    : Boolean(bookingData?.assignPartner);
                  const partnerOptions = matchedPartners?.map((partner) => ({
                    label: partner.companyName,
                    value: partner._id,
                  }));

                  return (
                    <div className="qh-assign">
                      <Select
                        className="qv-select"
                        styles={selectStyles}
                        placeholder="Select vendor"
                        options={partnerOptions}
                        value={partnerOptions.find((option) => option.value === selectedPartner) || null}
                        onChange={(selected) => setSelectedPartner(selected.value)}
                        isDisabled={isDisabled}
                        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                        noOptionsMessage={() => "No matching vendors"}
                      />
                      <button
                        type="button"
                        className="qd-btn qd-btn-primary"
                        onClick={handleAssignPartner}
                        disabled={isDisabled || assignLoading}
                      >
                        {assignLoading
                          ? "Please wait..."
                          : bookingData?.assignPartner && lastAcceptedAdminQuotation?.status === "accepted"
                            ? "Already assigned to vendor"
                            : "Assign order to vendor"}
                      </button>
                    </div>
                  );
                })()}

              {bookingData?.assignPartner && (
                <div className="qh-vendor">
                  <div className="qh-vendor-avatar">
                    {(bookingData.assignPartner.companyName || "?").trim().charAt(0).toUpperCase()}
                  </div>
                  <div className="qh-vendor-info">
                    <strong>{bookingData.assignPartner.companyName}</strong>
                    {bookingData.assignPartner.email && (
                      <span>
                        <FiMail /> {bookingData.assignPartner.email}
                      </span>
                    )}
                    {bookingData.assignPartner.phone && (
                      <span>
                        <FiPhone /> {bookingData.assignPartner.phone}
                      </span>
                    )}
                  </div>
                </div>
              )}

              <button
                type="button"
                className="qd-btn qd-btn-outline qh-full-btn"
                disabled={!bookingData?.assignPartner}
                onClick={() => {
                  if (bookingData?.assignPartner) {
                    handleChatType("partner");
                  }
                }}
              >
                <FiMessageSquare /> Chat with vendor
              </button>
            </section>
          )}

          {!bookingData && (
            <section className="qd-card qh-card">
              <Skeleton height={40} width="100%" count={4} />
            </section>
          )}

          {/* Admin: customer quotation */}
          {bookingData &&
            userRole === "admin" &&
            renderQuotationCard({
              title: "Send quotation / document / file (Customer)",
              lockedTitle: "Send quotation / document / file",
              lockedDisabled: lastAcceptedAdminQuotation?.status === "accepted",
              historyTitle: "Quotation / document / file status (Customer)",
              historyItemLabel: "Quotation / document / file status",
            })}

          {/* Admin: vendor quotations */}
          {bookingData && userRole === "admin" && partnerQuotationHistory.length > 0 && (
            <section className="qd-card qh-card">
              {renderSectionHead(MdStorefront, "Vendor quotation / document / file status")}
              <div className="qh-quote-list">
                {partnerQuotationHistory.map((event, index) => {
                  const isLatestPartnerQuotation = index === partnerQuotationHistory.length - 1;
                  const canActOnPartnerQuotation =
                    event?.status === "opening" && isLatestPartnerQuotation;

                  return (
                    <div className="qh-quote" key={event?._id || index}>
                      <div className="qh-quote-main">
                        <div className="qh-quote-title">
                          <span>Vendor : Quotation status</span>
                          <span className={`qc-status ${quotationPillClass(event)}`}>
                            <span className="qu-dot" />
                            {getQuotationStatusLabel(event)}
                          </span>
                        </div>
                        <p>{event.reason || "-"}</p>
                        <small>{moment(event.createdAt).format("DD MMM YYYY, hh:mm A")}</small>
                      </div>
                      <div className="qh-quote-actions">
                        <button
                          type="button"
                          className="qh-attach-btn"
                          onClick={() => handleView(event?.quotationPdf)}
                        >
                          <FiPaperclip /> View attachment
                        </button>
                        {canActOnPartnerQuotation && (
                          <div className="qd-bookings-tools">
                            <button
                              type="button"
                              className="qd-btn qd-btn-sm qp-delete-btn"
                              onClick={() => handleOpenPartnerQuotationAction(event, "rejected")}
                              disabled={quotationActionLoading}
                            >
                              Reject
                            </button>
                            <button
                              type="button"
                              className="qd-btn qd-btn-sm qd-btn-primary"
                              onClick={() => handleOpenPartnerQuotationAction(event, "accepted")}
                              disabled={quotationActionLoading}
                            >
                              Accept
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          )}

          {/* Vendor: own quotation */}
          {bookingData &&
            userRole === "partner" &&
            bookingData?.isAccepted === true &&
            renderQuotationCard({
              title: "Send quotation / document / file",
              lockedTitle: "Send quotation / document / file",
              lockedDisabled: lastAcceptedPartnerQuotation?.status === "accepted",
              historyTitle: "Quotation status",
              historyItemLabel: "Quotation status",
            })}
        </div>
      </div>

      {/* ================= MODALS ================= */}
      <ConfirmationModal
        show={deleteConfirmation.show}
        title="Delete order status"
        message="Are you sure you want to delete this order status."
        onConfirm={confirmDeleteHistory}
        onCancel={() => setDeleteConfirmation({ show: false, status: null })}
        confirmText={
          deleteLoading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Deleting...
            </>
          ) : (
            "Yes, delete"
          )
        }
        confirmDisabled={deleteLoading}
        cancelText="Cancel"
      />

      <ConfirmationModal
        show={quotationActionConfirmation.show}
        title={
          quotationActionConfirmation.status === "accepted" ? "Accept quotation" : "Reject quotation"
        }
        message={
          quotationActionConfirmation.status === "accepted"
            ? "Are you sure you want to accept this vendor quotation?"
            : null
        }
        onConfirm={handlePartnerQuotationAction}
        onCancel={handleClosePartnerQuotationAction}
        confirmText={
          quotationActionLoading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Processing...
            </>
          ) : quotationActionConfirmation.status === "accepted" ? (
            "Yes, accept"
          ) : (
            "Reject"
          )
        }
        confirmDisabled={
          quotationActionLoading ||
          (quotationActionConfirmation.status === "rejected" && !reasonQuotationMessage.trim())
        }
        cancelText="Cancel"
        contentClassName={
          quotationActionConfirmation.status === "rejected" ? "rejectQuotationModal" : ""
        }
      >
        {quotationActionConfirmation.status === "rejected" && (
          <div className="rejectQuotationContent">
            <p>Are you sure you want to reject this quotation? This action cannot be undone.</p>
            <textarea
              value={reasonQuotationMessage}
              onChange={(e) => setReasonQuotationMessage(e.target.value)}
              placeholder="Enter rejection reason..."
              rows={4}
              className="qb-modal-input"
            />
          </div>
        )}
      </ConfirmationModal>

      <ConfirmationModal
        show={confirmationShipping.show}
        title={isTransitStatus ? "Add custom tracking status" : "Update status"}
        message={
          isTransitStatus ? (
            <div className="qb-transit-form">
              <p>Please enter a custom tracking status for the user to see:</p>
              <input
                type="text"
                className="qb-modal-input"
                placeholder="Custom tracking status"
                value={confirmationShipping.customStatus || ""}
                onChange={(e) =>
                  setConfirmationShipping({
                    ...confirmationShipping,
                    customStatus: e.target.value,
                  })
                }
              />
              <textarea
                className="qb-modal-input"
                placeholder="Enter here message"
                value={confirmationShipping.messageText || ""}
                onChange={(e) =>
                  setConfirmationShipping({
                    ...confirmationShipping,
                    messageText: e.target.value,
                  })
                }
              />
              <div className="qb-upload">
                <input
                  type="file"
                  name="file"
                  id="attachmentUpload"
                  ref={fileInputRef}
                  accept="image/*,application/pdf"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                <label htmlFor="attachmentUpload">Click to upload file</label>
                <p>PNG, JPG, PDF, DOC (Max 5MB)</p>

                {confirmationShipping?.attachment && (
                  <div className="qb-upload-file">
                    <span>📎 {confirmationShipping.attachment.name}</span>
                    <button
                      type="button"
                      onClick={() =>
                        setConfirmationShipping((prev) => ({
                          ...prev,
                          attachment: "",
                        }))
                      }
                    >
                      Remove
                    </button>
                  </div>
                )}
              </div>
            </div>
          ) : (
            `Are you sure you want to update the status to "${confirmationShipping.statusValue.replace(
              /\b\w/g,
              (char) => char.toUpperCase(),
            )}"?`
          )
        }
        onConfirm={handleConfirm}
        onCancel={() =>
          setConfirmationShipping({
            show: false,
            orderId: null,
            statusValue: "",
            customStatus: "",
            messageText: "",
            attachment: "",
          })
        }
        confirmText={
          confirmLoading ? (
            <span className="confirm-loading">
              <span className="confirm-spinner" />
              Confirming...
            </span>
          ) : isTransitStatus ? (
            "Save status"
          ) : (
            "Confirm"
          )
        }
        confirmDisabled={confirmLoading}
        cancelText="Cancel"
      />
    </div>
  );
}

function getCreatedChatRoomId(response) {
  const data = response?.data?.data ?? response?.data;
  const candidates = [
    data?.room?._id,
    data?.chatRoom?._id,
    data?.roomId,
    data?._id,
    data?.data?.room?._id,
    data?.data?.chatRoom?._id,
    data?.data?.roomId,
  ];

  return candidates.find(Boolean) || "";
}
